import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { adOperationsPath } from './TaapTabs';

/** Keep bookmarked dashboard links pointing at the unified workspace. */
export default function TaapDashboardRedirect() {
  const { search } = useLocation();
  return <Navigate to={adOperationsPath('/taap', search)} replace />;
}
